import { useEffect } from "react"

import { Analytics } from "utils/analytics"
import { Headline3, Modal } from "ui-kit/components-branded/index"
import { ClientCardAttachment } from "components"
import { PaymentMethod } from "modules/ClientAccount/utils"
import style from "modules/ClientAccount/components/AttachCard/style.module.scss"
import { AutoPaymentText } from "modules/ClientAccount/components/AutoPaymentText"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
interface Props {
    isModalOpen: boolean
    setIsModalOpen: (isModalOpen: boolean) => void
    cards?: PaymentMethod[]
}

export function AttachCard({ setIsModalOpen, isModalOpen, cards }: Props) {
    const [{ userAccount: clientUserAccount }] = useClientContext()
    const isB2b = clientUserAccount.is_b2b

    useEffect(() => {
        isModalOpen && Analytics.card_shown()
    }, [isModalOpen])

    const closeWithoutAttach = () => {
        Analytics.card_no_sign()
        setIsModalOpen(false)
    }

    const closeWithAttachCard = () => {
        if (!cards) {
            Analytics.card_1st_success()
        } else {
            Analytics.card_more_success()
        }

        setIsModalOpen(false)
    }

    return (
        <Modal
            onBackgroundClick={closeWithoutAttach}
            isActive={isModalOpen}
            className={style.attachCardModal}
        >
            <Modal.Content
                className={style.content}
                onCloseClick={closeWithoutAttach}
                data-testid="clientacc-attach-card-modal"
            >
                <div className={style.header}>
                    <Headline3 className={style.title}>Привязать новую карту</Headline3>
                    {!isB2b && <AutoPaymentText />}
                </div>
                <div className={style.yookassaWrapper}>
                    {isModalOpen && <ClientCardAttachment onClose={closeWithAttachCard} />}
                </div>
            </Modal.Content>
        </Modal>
    )
}
